module.exports = __webpack_public_path__ + "static/media/a2lg.bf252c41.png";